import {getChannelsByProps_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import CustomLazyPagination from 'modules/asyncCache/components/CustomLazyPagination'
import React, {useContext, useMemo} from 'react'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {renderChannelItem} from 'views/MainPage/functions/renderChannelItem'
import OrganizationContainerContext from '../OrganizationContainerContext'
import useTranslate from '../../../../modules/local/useTranslate'
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {RiSignalTowerFill} from "react-icons/ri";
import {Link} from "react-router-dom";
import getTitle from "../../../../helpers/getTitle";
import Pure from "../../../../components/Pure";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FaWandMagicSparkles} from "react-icons/fa6";
import Translate from "../../../../modules/local/Translate";

const OrganizationChannelList = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {organization: item} = useContext(OrganizationContainerContext)

    const [id, type] = [getId(item), getType(item)]

    const apiInfo = getChannelsByProps_Api

    const lookupKey = useMemo(
        () => [apiInfo.path.replace(':id', id).replace(':type', type)].join('/'),
        [id, type, apiInfo]
    )

    if (_.isEmpty(item)) return null

    return (
        <Wrapper className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h2 className="font-bold text-lg text-gray-800 tracking-wide uppercase">
                    {t('channel')}
                </h2>
                <div className="text-color-300 tracking-wider">
                    {t('channel introduction description')}
                </div>
            </div>
            <div className="flex flex-col gap-4">
                <Pure input={[id, type]}>
                    <CustomLazyPagination
                        id={lookupKey}
                        key={lookupKey}
                        apiInfo={apiInfo}
                        query={bindQueryParams([{id}, {type}])}
                        renderEmpty={() => <EmptyHolder/>}
                        renderItem={renderChannelItem}
                    />
                </Pure>
            </div>
            <div className="h-10"/>
        </Wrapper>
    )
}

const renderChannelItemSider = ({isLg}) => (item, index) => {

    return (
        <Translate>
            {(t) => (
                <div key={index} className="px-3 py-2 background-50 hover:scale-2xs hover:shadow-md rounded-xl">
                    <div className="mb-2 pb-2 border-b">
                        <Link
                            to={getLinkToDetail(item)}
                            className="font-bold text-base text-color-000 tracking-wide max-lines-1 no-underline">
                            {getTitle(item)}
                        </Link>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-xs text-color-100 italic tracking-wider lowercase">
                            <strong>{item?.total_followers}</strong> {t('followers')}
                        </span>
                        {!!item?.selected_by_editor && (
                            <span className="h-6 px-3 py-1 flex flex-center font-medium text-xs text-blue-500 bg-blue-100 tracking-wide rounded-full">
                                <FaWandMagicSparkles size={10} className="mr-1"/>
                                {!!isLg && t("editor's choice")}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}

export const OrganizationChannelSider = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {organization: item} = useContext(OrganizationContainerContext)
    const {isLg} = useContext(LayoutContext)
    const history = useHistory()

    const [id, type] = [getId(item), getType(item)]

    const apiInfo = getChannelsByProps_Api

    if (_.isEmpty(item)) return null

    return (
        <CustomLazyPaginationWrapper
            id={[apiInfo.path, type, id].join("/")}
            sample={2}
            auto={true}
            apiInfo={apiInfo}
            query={bindQueryParams([{id}, {type}])}
            renderEmpty={() => <EmptyHolder title={null}/>}
            renderItem={renderChannelItemSider({isLg})}
            renderLoading={renderPagingLoading}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <WrapperBlockSider
                        title="channel" titleColor="text-blue-600"
                        expanded={!isLg}
                        borderLeft={isLg}
                        borderTop={!isLg}
                        icon={<RiSignalTowerFill size={18} className="text-blue-600"/>}>
                        <div className="flex flex-col gap-4">
                            {children}
                        </div>
                    </WrapperBlockSider>
                )
            }}
            renderLoadMoreButton={() => (
                <span
                    className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg');
                        history.push(getLinkToDetail(item) + '/channels')
                    }}>
                    <span className="text-xs italic">
                        {t('see more')}
                    </span>
                    <FiChevronsRight size={13} className="my-auto"/>
                </span>
            )}
        />
    )
}

export default OrganizationChannelList
